interface HeaderTechConstantInterface {
  Array: TechnologyInterface
}

interface HeaderServiceConstantInterface {
  [key: string]: TechnologyInterface
}

export interface TechnologyInterface {
  title: string
  titleNoLink: string
  shortdesc: string
  description: string
  tags: Array<any>
  id: string
  link: string
  className: string
}

export interface ServicesInterface {
  title: string
  titleNoLink: string
  shortdesc: string
  description: string
  tags: Array<any>
  id: string
  link: string
  className: string
}
export const HeaderTechConstant: Array<TechnologyInterface> = [
  {
    title: '',
    titleNoLink: 'Backend Technologies',
    shortdesc:
      'Back-end technology is the term given to the tools and solutions used to program the server-side functions of the application. This includes working with programming languages and web frameworks to work on the operating systems of the solution.',
    link: '',
    id: 'Backend_Technology',
    description:
      'Build high-performing architectures for the backend of your app.',
    tags: [
      {
        tag: 'Node js',
        subid: 'Node.js',
        sublink: '/nodejs-development-services',
        tagtitle: 'Node.JS Development',
        dec: 'Node.Js is hailed as an excellent server-side platform for building software and network applications.',
      },
      {
        tag: '.Net',
        subid: 'Net',
        sublink: '/dot-net-development-company',
        tagtitle: '.NET Development',
        dec: '.Net is built by Microsoft, and we employ it to build web applications and services.',
      },
      {
        tag: 'Python',
        subid: 'Python',
        sublink: '/python-development-company',
        tagtitle: 'Python Development',
        dec: 'We use Python to write programs for applications and software focusing on data visualization and analysis.',
      },
      {
        tag: 'Rust',
        subid: 'rust',
        sublink: '/rust-development-services',
        tagtitle: 'Rust Development',
        dec: 'Rust is a modern, open-source, and community-driven programming language.',
      },
      {
        tag: 'Java',
        subid: 'Java',
        sublink: '/java-development-services',
        tagtitle: 'Java Development',
        dec: 'Java is a high-level OOP language having a wide range of use cases and capabilities that we successfully leverage.',
      },
      {
        tag: 'PHP',
        subid: 'Php',
        sublink: '/php-development-services',
        tagtitle: 'PHP Development',
        dec: 'As a general-purpose programming language, PHP is well suited for web development and helps build fast and pragmatic solutions.',
      },
      {
        tag: 'GoLang',
        subid: 'Go',
        sublink: '/goLang-development-services',
        tagtitle: 'GoLang Development',
        dec: 'As a general-purpose programming language, PHP is well suited for web development and helps build fast and pragmatic solutions.',
      },
    ],
    className: 'bdr_up bdr_b_l',
  },
  {
    title: '',
    titleNoLink: 'Frontend Technologies',
    shortdesc:
      'The frontend technology package caters to the visual aspects of web and mobile solutions. Frontend developers use different web development technologies to design and develop impressive visual designs to offer immersive user experiences.',
    link: '',
    id: 'Frontend_Technologies',
    description:
      'Leverage cutting-edge technologies to design seamless user interface for apps.',
    tags: [
      {
        tag: 'React js',
        subid: 'React_js',
        sublink: '/react-js-development-services',
        tagtitle: 'React.Js Development',
        dec: 'ReactJS is a JavaScript library and a declarative technology that creates highly interactive user interfaces.',
      },
      {
        tag: 'Angular js',
        subid: 'Angular',
        sublink: '/angularjs-development-services',
        tagtitle: 'Angular Development',
        dec: 'Angular is an open-source technology used to build mobile and single-page web applications with compelling user interfaces.',
      },
      {
        tag: 'Vue js',
        subid: 'Vue_js',
        sublink: '/vuejs-development-company',
        tagtitle: 'Vue.Js Development',
        dec: 'With Vue.Js, we build responsive web interfaces and one-page applications for mobile and desktop devices.',
      },
      {
        tag: 'Next js',
        subid: 'js',
        sublink: '/nextjs-development-company',
        tagtitle: 'Next Development',
        dec: 'Create static & dynamic feature-rich websites & apps using Next.Js. Our developers can help you build fast & reliable solutions.',
      },
      {
        tag: 'HTML5',
        subid: 'HTML5',
        sublink: '/html5-development',
        tagtitle: 'HTML5 Development',
        dec: 'Mobile web application development can be done best with HTML5. Our developers have extensive experience with HTML5.',
      },
      {
        tag: 'TypeScript',
        subid: 'Typescript',
        sublink: '/typescript-development-services',
        tagtitle: 'TypeScript Development',
        dec: 'TypeScript is a superset programming framework of JavaScript & works as an open-source compiler to make efficient apps.',
      },
    ],
    className: 'bdr_up bdr_b2',
  },
  {
    title: '',
    titleNoLink: 'Mobile Technologies',
    shortdesc:
      'WebClues mobile app development technologies are selected according to their capabilities, support, and ability to help build advanced applications. Our mobile technology stack is the perfect combination that every business needs.',
    link: '',
    id: 'Mobile_Technologies',
    description:
      'Expert at building cross platform mobile apps for iOS, Android, and Windows.',
    tags: [
      {
        tag: 'React Native',
        subid: 'React_js',
        sublink: '/react-native-app-development',
        tagtitle: 'React Native Development',
        dec: 'Besides offering great performance, React helps build interactive single-page applications of any size and industry.',
      },
      {
        tag: 'Flutter',
        subid: 'Flutter',
        sublink: '/flutter-app-development',
        tagtitle: 'Flutter Development',
        dec: 'Hailed as one of the best cross-platform technologies Flutter helps easily build applications for Android, iOS, and other platforms.',
      },
      {
        tag: 'Swift',
        subid: 'swift',
        sublink: '/swift-app-development',
        tagtitle: 'Swift Development',
        dec: 'Swift is a powerful and intuitive programming language. We offer numerous Swift-oriented app development services for native iOS development.',
      },
      {
        tag: 'Kotlin',
        subid: 'Kotlin',
        sublink: '/kotlin-app-development',
        tagtitle: 'Kotlin Development',
        dec: 'WebClues dispense a number of Kotlin-oriented services for business enterprises. We rely on Kotlin to develop complex programs with high-order functions.',
      },
      {
        tag: 'iOS',
        subid: 'Ios',
        sublink: '/ios-app-development',
        tagtitle: 'iOS Development',
        dec: 'WebClues uses the best iOS mobile application development technologies to build powerful apps with fluid design and customized features.',
      },
      {
        tag: 'Android',
        subid: 'Android',
        sublink: '/android-app-development-services',
        tagtitle: 'Android Development',
        dec: 'Touted as the perfect choice for startups, Android app development is highly scalable, covering a broader market.',
      },
      {
        tag: 'Ionic',
        subid: 'Ionic_app',
        sublink: '/ionic-app-development',
        tagtitle: 'Ionic App Development',
        dec: 'Ionic is known for building progressive web applications for every mobile device and platform with nativity.',
      },
      {
        tag: 'Xamarin',
        subid: 'Xamarin_app',
        sublink: '/xamarin-development',
        tagtitle: 'Xamarin Development',
        dec: 'Xamarin is known to provide seamless functionality and code-reusability with access to native APIs.',
      },
    ],
    className: 'bdr_b_r',
  },
  {
    title: '',
    titleNoLink: 'Frameworks We Use',
    shortdesc:
      'Frameworks provide a common development environment and structure to the developers. Using the frameworks means we don’t have to write the code from scratch, which substantially reduces the development time and cost.',
    link: '',
    id: 'Frameworks',
    description:
      'Engineer your app to perfection with our state-of-the-art frameworks that deliver exceptional outcomes.',
    tags: [
      {
        tag: 'MERN',
        subid: 'Mern',
        sublink: '/hire-mern-stack-developers',
        tagtitle: 'MERN Development',
        dec: 'MongoDB, Express, React, and Node make the MERN stack, which is a great technologies group for building websites and web applications.',
      },
      {
        dec: 'MEAN expands as MongoDB, Express, Angular, and Node. These are four amazing web development technologies based on JavaScript.',
        tagtitle: 'MEAN Development',
        sublink: '/hire-mean-stack-developers',
        tag: 'MEAN',
        subid: 'Mean',
      },
      {
        dec: 'Our certified .NET Core framework experts can assist your in-house team with web and mobile application development.',
        tagtitle: 'DotNet Core',
        sublink: '/dot-net-core-development-services',
        tag: 'DotNet Core',
        subid: 'Dotnet_core',
      },
      {
        dec: 'We create multi-tier MVC APIs for various CRUD actions and full-fledged codebases for web and mobile applications.',
        tagtitle: 'DotNet MVC',
        sublink: '/hire-asp-dotnet-mvc-developers',
        tag: 'DotNet MVC',
        subid: 'Dotnet_mvc',
      },
      {
        dec: 'When the task is to complete the development process rapidly with clean and pragmatic programming and designing, we use Django.',
        tagtitle: 'Django Development',
        sublink: '/django-development',
        tag: 'Django',
        subid: 'Django',
      },
      {
        dec: 'With Flask added to our technology stack, we can build web applications, microservices, and APIs in no time.',
        tagtitle: 'Flask Development',
        sublink: '/flask-web-development',
        tag: 'Flask',
        subid: 'Flask',
      },
      {
        dec: 'Laravel follows the model-view-controller architectural pattern to build smart and fast web applications.',
        tagtitle: 'Laravel Development',
        sublink: '/laravel-development-services',
        tag: 'Laravel',
        subid: 'Larvel',
      },
      {
        dec: 'CodeIgniter is based on PHP and used to build dynamic websites with an open-source development environment. ',
        tagtitle: 'CodeIgniter',
        sublink: '/codeigniter-development-services',
        tag: 'Codeignitor',
        subid: 'Codeignitor',
      },
      {
        dec: 'WordPress is the world’s most popular solution for managing websites in almost every industry and adding eCommerce capabilities.',
        tagtitle: 'WordPress Development',
        sublink: '/wordpress-development-services',
        tag: 'WordPress',
        subid: 'Wordpress',
      },
      {
        dec: 'Spring is an open source Java platform. With its comprehensive infrastructure support we develop robust Java applications very easily and rapidly.',
        tagtitle: 'Spring Development',
        sublink: '/spring-development',
        tag: 'Spring',
        subid: 'Spring',
      },
      {
        dec: 'It reduces development time & maintenance cost. Developer’s work is reduced to a great extent as it takes care of the changes made to the database automatically.',
        tagtitle: 'Hibernate Development',
        sublink: '/hibernate-development',
        tag: 'Hibernate',
        subid: 'Hibernate',
      },
    ],
    className: 'bdr_down bdr_b',
  },
  {
    title: '',
    titleNoLink: 'Cloud Technologies',
    shortdesc:
      'Cloud technologies allow to access and store data quickly and securely in the cloud, enabling to make faster decisions and improve efficiency. We provide access to powerful analytics tools, so you can gain valuable insights into your customers and operations.',
    link: '',
    id: 'Cloud_Technologies',
    description:
      'Digitally transform your business to a cloud-based model for higher scalability.',
    tags: [
      {
        dec: 'It is the most comprehensive, reliable, and secure global cloud infrastructure. With us, your business will be empowered by the capabilities of this platform.',
        tagtitle: 'AWS Development',
        sublink: '/aws-development',
        tag: 'AWS',
        subid: 'Aws',
      },
      {
        dec: 'Azure offers a comprehensive suite of cloud services that businesses of all sizes can use to improve their operations. Join hands with us and design exactly what you need.',
        tagtitle: 'Azure Development',
        sublink: '/azure-development-services',
        tag: 'Azure',
        subid: 'Azure',
      },
      {
        dec: 'Employ advanced Google Cloud Computing services to collaborate with better analytics and onsite server solutions. We offer Google Cloud services for achieving transformative outcomes.',
        tagtitle: 'Google Cloud',
        sublink: '/google-cloud-services',
        tag: 'Google Cloud',
        subid: 'Google_cloud',
      },
      {
        dec: 'We help businesses scale & improve their business outcomes with intelligent development powered by IBM Watson.',
        tagtitle: 'IBM Watson',
        sublink: '/ibm-watson-developer',
        tag: 'IBM Watson',
        subid: 'Ibm_watson',
      },
      // {
      //   dec: 'Take Advantage Of Android App Expand Your Digital Presence',
      //   tagtitle: 'Rasa Development',
      //   sublink: 'javascript:;',
      //   tag: 'Rasa',
      //   subid: 'Rasa',
      // },
    ],
    className: 'bdr_down bdr',
  },
]

export const HeaderServiceConstant: Array<ServicesInterface> = [
  {
    title: 'Team Extension',
    titleNoLink: '',
    shortdesc: '',
    id: 'Team_Extension',
    link: '/hire-dedicated-developers',
    description:
      'Get the finest web and app developers that match your project level and assure you the best outcome.',
    tags: [],
    className: 'bdr_up bdr_b_l',
  },
  {
    title: 'Product Engineering',
    titleNoLink: '',
    shortdesc: '',
    id: 'Product_Engineering',
    link: '/product-engineering-services',
    description:
      'Deploy your product into the market at swift speed with our streamlined development services.',
    tags: [],
    className: 'bdr_up bdr_b2',
  },
  {
    title: 'Web Development',
    titleNoLink: '',
    shortdesc: '',
    id: 'Web_Development',
    link: '/web-development-services',
    description:
      'Leveraging the benefits of finest technologies in developing secure & scalable web solutions.',
    tags: [],
    className: 'bdr_up bdr_b2',
  },
  {
    title: 'Mobilty Solutions',
    titleNoLink: '',
    shortdesc: '',
    id: 'Mobilty_Solutions',
    link: '/mobile-app-development-services',
    description:
      'Modernize your existing application & get a new functional & productive app for your business.',
    tags: [],
    className: 'bdr_b_r',
  },
  {
    title: '',
    titleNoLink: 'Emerging Tech',
    shortdesc: '',
    id: 'Emerging_Tech',
    link: '',
    description:
      'Bring in your ideas to design & develop unique applications & simplify their complexity using smart tech.',
    tags: [
      {
        sublink: '/blockchain-development-services',
        tag: 'Blockchain',
        subid: 'Blockchain',
      },
      {
        sublink: '/ai-ml-development-services',
        tag: 'AI/ML',
        subid: 'AI/ML',
      },
      {
        sublink: '/chatbots-development',
        tag: 'Chatbot App',
        subid: 'ChatbotApp',
      },
      {
        sublink: '/iot-app-development-company',
        tag: 'IoT',
        subid: 'IOT',
      },
      {
        sublink: '/data-analytics-services',
        tag: 'Data Analytics',
        subid: 'Data_Analytices',
      },
    ],
    className: 'bdr_up bdr_b_l bdr_r',
  },
  {
    title: '',
    titleNoLink: 'E-Commerce',
    shortdesc: '',
    id: 'E_Commerce',
    link: '',
    description:
      'Get a highly engaging and simplistic eCommerce app with comprehensive features.',
    tags: [
      {
        sublink: '/magento-development-services',
        tag: 'Magento',
        subid: 'Magento',
      },
      {
        sublink: '/shopify-development-services',
        tag: 'Shopify',
        subid: 'Shopify',
      },
      {
        sublink: '/opencart-development-services',
        tag: 'OpenCart',
        subid: 'OpenCart',
      },
      {
        sublink: '/prestashop-development-services',
        tag: 'PrestaShop',
        subid: 'Prestashop',
      },
      {
        sublink: '/woocommerce-development-services',
        tag: 'WooCommerce',
        subid: 'Woocommerce',
      },
      {
        sublink: '/drupal-development-services',
        tag: 'Drupal',
        subid: 'Drupal',
      },
    ],
    className: 'bdr_r bdr_b2',
  },
  {
    title: '',
    titleNoLink: 'Cyber Security',
    shortdesc: '',
    id: 'Cyber_Security',
    link: '',
    description:
      'Safeguard your organization from potential cyberattacks and ensure its resilience against emerging threats.',
    tags: [
      {
        sublink: '/penetration-testing-services',
        tag: 'Penetration Testing',
        subid: 'Penetration Testing',
      },
    ],
    className: 'bdr_r bdr_b2',
  },

  {
    title: 'Cloud And DevOps',
    titleNoLink: '',
    shortdesc: '',
    id: 'Cloud_And_Devops',
    link: '/cloud-devops-services',
    description:
      'Accelerate your development cycle by building reliable & robust software solutions for your workflows.',
    tags: [],
    className: 'bdr_b_r',
  },
  {
    title: 'Quality Analyst',
    titleNoLink: '',
    shortdesc: '',
    id: 'Quality_Analyst',
    link: '/quality-assurance-services',
    description:
      'Improve the quality of your code with our refined testing procedures that deliver only the best outcomes.',
    tags: [],
    className: 'bdr_down',
  },
  {
    title: 'UI/UX Design',
    titleNoLink: '',
    shortdesc: '',
    id: 'UI/UX_Design',
    link: '/ui-ux-design-services',
    description:
      'Build highly attractive, intuitive, and seamless user interfaces for your applications.',
    tags: [],
    className: 'bdr_down',
  },
]
